import { render, staticRenderFns } from "./TabDetalle.vue?vue&type=template&id=60ba9d3e&scoped=true&"
import script from "./TabDetalle.vue?vue&type=script&lang=js&"
export * from "./TabDetalle.vue?vue&type=script&lang=js&"
import style0 from "./TabDetalle.vue?vue&type=style&index=0&id=60ba9d3e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60ba9d3e",
  null
  
)

export default component.exports